const c = (t) => t === document || t === document.body, u = (t, o) => {
  if (t === null || t === document.body)
    return document.body;
  if (!t)
    return null;
  if (t === document)
    return document;
  const {
    overflow: n,
    overflowY: i,
    overflowX: r
  } = window.getComputedStyle(t, null);
  return /(auto|scroll)/.test([n, i].join("")) ? t : u(t.parentNode);
}, d = (t, o) => {
  if (t && o) {
    const n = t.getBoundingClientRect().top;
    if (o === document.body || o === document)
      return n;
    const i = o.getBoundingClientRect().top;
    return n - i;
  }
  return 0;
}, s = (t, o, n = !1) => {
  if (t && typeof t.getBoundingClientRect == "function" && o) {
    const r = n ? t.getBoundingClientRect().top : t.getBoundingClientRect().bottom;
    return o === document.body || o === document ? window.innerHeight - r : o.getBoundingClientRect().bottom - r;
  }
  return 0;
};
function g(t, o) {
  return t != null && t.target && o ? t.target === o || o.contains(t.target) : !1;
}
function f(t) {
  if (t) {
    const o = window.getComputedStyle(t, null), n = parseInt(o.width, 10) || t.offsetWidth, i = parseInt(o.height, 10) || t.offsetHeight, r = n + parseInt(o.marginRight, 10) + parseInt(o.marginLeft, 10);
    return { height: i + parseInt(o.marginTop, 10) + parseInt(o.marginBottom, 10), width: r };
  }
  return { width: "auto", height: "auto" };
}
export {
  s as distanceToBottomEdge,
  d as distanceToTopEdge,
  f as getElementWidthAndHeight,
  u as getScrollParent,
  c as isDocument,
  g as targetContainsClickEvent
};
//# sourceMappingURL=design-system.es140.js.map
